exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background:#ececec;font-family:Tahoma,Arial,helvetica,sans-serif;font-size:100%;line-height:1em;color:#414141;min-width:1000px}.tail-top-right{background:url(" + require("../images/tail-top-right.gif") + ") repeat-x 100% 0;width:50%;position:absolute;right:0;top:0;height:359px}.tail-top{background:url(" + require("../images/tail-top.gif") + ") 0 0 repeat-x #fff}.tail-bottom{background:url(" + require("../images/tail-bottom.gif") + ") 0 100% repeat-x}.index img{margin:40px auto;border-radius:4px;background:#fff;display:block}.index .notice{margin:20px auto;padding:15px 0;text-align:center;border:1px solid #000;border-width:1px 0;background:#666}#main{width:1000px;margin:0 auto;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/App.css
// module id = 133
// module chunks = 0